import { Box } from "@mui/material";
import { type DragEvent, type FC } from "react";
import { PaginationWrapper } from "../generic/components/pagination-wrapper";
import { AssetCard } from "./asset-card";
import { FolderCard } from "./folder-card";
import type { Asset } from "./server/digital-asset-service";
import type { Folder } from "./server/folder-service";

export const AssetGrid: FC<{
  assets: Asset[];
  designer?: string | null;
  onClick?: (asset: Asset) => void;
  folders?: Folder[];
  showFolders?: boolean;
  onAssetDragStart?: (asset: Asset, event: DragEvent) => void;
  onFolderDragStart?: (folder: Folder, event: DragEvent) => void;
  onFolderDragOver?: (event: DragEvent) => void;
  onFolderDrop?: (folderId: Folder["id"], event: DragEvent) => void;
}> = ({
  assets,
  designer,
  onClick,
  folders,
  showFolders = true,
  onAssetDragStart,
  onFolderDragStart,
  onFolderDragOver,
  onFolderDrop,
}) => {
  return (
    <PaginationWrapper
      data={assets}
      itemsPerPage={25}
      renderPage={(data) => (
        <Box display="grid" gap={4} gridTemplateColumns="repeat(auto-fit, minmax(200px, 305px))">
          {showFolders &&
            folders?.map((folder) => (
              <FolderCard
                key={folder.id}
                folder={folder}
                draggable={Boolean(onFolderDragStart)}
                onDragStart={
                  onFolderDragStart ? (event) => onFolderDragStart(folder, event) : undefined
                }
                onDragOver={onFolderDragOver}
                onDrop={onFolderDrop ? (event) => onFolderDrop(folder.id, event) : undefined}
              />
            ))}
          {data.map((asset) => (
            <AssetCard
              key={asset.id}
              asset={asset}
              data-testid="asset"
              onClick={() => onClick?.(asset)}
              designer={designer}
              draggable={Boolean(onAssetDragStart)}
              onDragStart={onAssetDragStart ? (event) => onAssetDragStart(asset, event) : undefined}
            />
          ))}
        </Box>
      )}
    />
  );
};
